interface UploadTagsWizardState {
  inaccessibleProjectNames: string[],
  page: UploadTagsWizardSteps,
  redirectToView: boolean,
  reviewData: UploadTagsReviewResponseModel,
  tagsFile: FormData,
}

interface ResourceTagModel {
  resourceTagId?: number;
  resourceId?: number;
  tagGroupId?: number;
  tagGroupName: string;
  tagId?: number;
  tagName: string;
}

interface UploadTagsReviewResponseModel {
  numProjects: number,
  numTags: number,
  tagGroups: TagGroup[],
}

interface TagGroup {
  name: string,
  tagNames: string[],
}

enum UploadTagsWizardSteps {
  "ImportList",
  "Review",
}

interface UploadTagsWizardStepProps {
  handleUpload?: (data: FormData) => Promise<void>,
  reviewData?: UploadTagsReviewResponseModel,
  wasSuccessful?: boolean,
}

interface CreateProjectTagModel {
  customProjectId: number
  projectName: string,
}

export {
  ResourceTagModel,
  UploadTagsWizardState,
  UploadTagsReviewResponseModel,
  UploadTagsWizardSteps,
  UploadTagsWizardStepProps,
  CreateProjectTagModel,
};
